/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions used to manipulate application state
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import OutOfContentScreen from 'components/screens/outofcontent/outofcontent';



/* ========== ~~~~~~~~~~ OUT OF CONTENT SCREEN: PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ embedStatus, contentData, contentStatus, settings, queueStatus }, { contentId }) => ({
    embedStatus,
    partnerLogo: settings.embedSettings.partnerLogo,
    frameData: !!contentId ? contentData[contentId].data[contentStatus[contentId].frame] : null,
    currentContentStatus: !!contentId ? contentStatus[contentId] : null,
    currentContentSettings: !!contentId ? settings.contentSettings[contentId] : null,
    contentId,
    settings
});

// map actions
const mapDispatchToProps = dispatch => ({});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    // mapDispatchToProps
)(OutOfContentScreen);
